(function() {
    'use strict';

    Odigeo.UIElements.dialogs = [];

    /**
     Generates a dialog with header, message and buttons
     @param {(String|Object)} options (headerText)- If is string to show in dialog header. If is an Object is parameter to configure dialog.
     @param {String} options.headerText - to show in dialog header
     @param {String|$} options.content - to show in dialog body
     @param {Array|$} options.buttons - buttons to show (objects with button description for createButton() method)
     @param {String} options.dialogClasses - string of classes to add in dialog
     @param {Boolean} options.hasCloseButton - flag which indicates if exists close button
     @param {String} options.imageClass - string of imageClass
     @param {Boolean} options.closeOnTapOuterBox flag which indicates if dialog must be closed when tap on outer of box dialog
     @param {String} options.dialogID the dialog id
     deprecated:
     @param {String|$} [content] - alias of options.content
     @param {Array|$} [buttons] - alias of options.buttons
     @param {String} [dialogClasses] alias of options.dialogClasses
     @param {Boolean} [hasCloseButton] - alias of options.hasCloseButton
     @param {String} [imageClass] - string of imageClass
     @param {String} [dialogID] - alias of options.dialogID
     @return {$} Dialog object
     */
    Odigeo.UIElements.createDialog = function(options, content, buttons, dialogClasses, hasCloseButton, imageClass, dialogID) {
        // Do you need another argument if you want to improve customization of dialog?
        // I think that doesn't.
        // Now dialog can be created with only one object parameter `options` and if you need add new customizations use properties of this object.
        // Notice: Old implementation is preserved to not break the code.
        var closeOnTapOuterBox;
        var closeOnNavigate;
        var hiddenCloseButton;
        var headerText = options;
        var footerText;
        if (_.isObject(options)) {
            headerText = options.headerText;
            content = options.content;
            buttons = options.buttons || [];
            dialogClasses = options.dialogClasses;
            hasCloseButton = options.hasCloseButton;
            imageClass = options.imageClass;
            closeOnTapOuterBox = options.closeOnTapOuterBox;
            closeOnNavigate = options.closeOnNavigate;
            footerText = options.footerText;
            hiddenCloseButton = options.hiddenClose;
            dialogID = options.dialogID;
        }

        var classes = (_.isArray(dialogClasses) ? dialogClasses.join(' ') : dialogClasses || '') + ' dialog-' + dialogID;
        var $dialog = $('<div>').addClass('od-ui-dialog dialog ' + classes)
            .append($('<div>').addClass('od-ui-dialog-content dialog_content'));

        var hideDialog = function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            Odigeo.UIElements.hideDialog($dialog);
            return false;
        };
        var stopPropagation = function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            return false;
        };
        this.dialogs.push($dialog);

        var $boxContent = _.isUndefined(imageClass) ?
            $('<div>').addClass('od-ui-dialog-box-content odf-flex-item odf-space-outer-s') :
            $('<div>').addClass('od-ui-dialog-box-content ' + imageClass);
        // If `content` is a $ instance allow appending it.
        $boxContent[content instanceof $ ? 'append' : 'html'](content);
        $dialog.find('.dialog_content')
            .append($('<div>').addClass('prisma-responsive-space-horizontal')
                .append($('<div>').addClass('ui_dialog_box cobalt-box warning')
                    .append($('<div>').addClass('header')
                        .append($('<div>').addClass('header-background'))
                        .append(hasCloseButton ?
                            $('<div>')
                                .addClass('dialog_close_hint_icon header-close odf-icon odf-icon-cross-light')
                                .addClass(hiddenCloseButton ? 'odf-hidden' : '')
                            : ''
                        )
                    )
                    .append(!_.isUndefined(imageClass) ? $('<div>').addClass('od-ui-dialog-image-' + imageClass)
                            .append($('<span>').addClass('ficon').append('F'))
                        : '')
                    .append($('<div>').addClass('odf-position-relative odf-z-index-1')
                        .append($('<div>').addClass('header-icon-container')
                            .append($('<div>').addClass('header-icon-centering')
                                .append($('<div>').addClass('odf-icon odf-icon-2xl odf-icon-warning'))
                            )
                        )
                    )
                    .append($('<div>').addClass('content')
                        .append($('<div>').addClass('odf-flex-container-column odf-text-center')
                            .append($('<h3>').addClass('odf-flex-item prisma-heading-md').html(headerText))
                            .append($boxContent)
                            .append($('<div>').addClass('dialog_footer'))
                        )
                    )
                )
            );
        if (footerText) {
            $dialog.find('.od-ui-dialog-box').append($('<div>').addClass('od-ui-dialog-box-post-footer dialog_post_footer').html(footerText));
        }

        var $buttonContainer = $dialog.find('.dialog_footer');

        $dialog.find('.dialog_dial_up').on(Odigeo.Events.tap, function() {
            var target = 'tel:' + this.attributes['attr-tel'].value;
            window.open(target, '_self');
        });

        if (hasCloseButton) {
            $dialog.find('.dialog_close_hint_icon').on(Odigeo.Events.tap, hideDialog);
        }
        if (closeOnTapOuterBox) {
            $dialog.find('.ui_dialog_box').on(Odigeo.Events.tap, stopPropagation);
            $dialog.on(Odigeo.Events.tap, hideDialog);
        }

        if (closeOnNavigate) {
            $dialog.on('dialog:closeOnNavigate', hideDialog);
        }

        var $button;

        _.each(buttons, function(btn) {
            if (btn instanceof $) {
                $button = btn;
            } else {
                $button = Odigeo.UIElements.createButton(btn);
            }

            $buttonContainer.append(
                $('<div>').addClass('odf-flex-item odf-flex-item-align-stretch odf-space-inner-top-s').append($button)
            );
        });

        if (dialogID) {
            $dialog.data('dialog-id', dialogID);
        }

        Odigeo.UIElements.dialog = $dialog; // TODO is this used at all?
        return $dialog.on(Odigeo.Events.touchmove, function(e) {
            e.preventDefault();
            e.stopPropagation();
        });
    };

    /**
     Attaches popup (dialog/notification/etc.) to the page
     @param {$} [$dialog] object representing popup
     @param {Boolean} [doNotScroll] do not scroll to top
     */
    Odigeo.UIElements.showDialog = function($dialog, doNotScroll) {
        $('.od_page.active .focused *').blur();
        $('.od_page.active select').each(function() {
            this.blur();
        });

        // Avoid scroll problems when showing a dialog
        if (Odigeo.SessionScope.flow === 'mobile') {
            // Hide keyboard
            _.delay(function() {
                $(':focus').blur();
            }, 300);

            // Show dialog and scroll to top
            _.delay(function() {
                Odigeo.Device.getViewport().append($dialog);
                $dialog.data('detached', false);
                if (!doNotScroll) {
                    $(window).scrollTop(0);
                }
            }, 500);
        } else {
            Odigeo.Device.getViewport().append($dialog);
            $dialog.data('detached', false);
        }

        Odigeo.trigger('dialogs:shown');
    };

    Odigeo.UIElements.toggleHideCloseButtonDialog = function($dialog, hide) {
        $dialog.find('.dialog_close_hint_icon').toggleClass('odf-hidden', hide);
    };

    Odigeo.UIElements.toggleCloseOutterClick = function($dialog, enable) {
        var stopPropagation = function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            return false;
        };

        var $uiDialog = $dialog.find('.ui_dialog_box');
        $uiDialog.off();
        $dialog.off();
        if (enable) {
            $uiDialog.on(Odigeo.Events.tap, stopPropagation);
            $dialog.on(Odigeo.Events.tap, function(evt) {
                stopPropagation(evt);
                Odigeo.UIElements.hideDialog($dialog);
                return false;
            });
        }
    };

    /**
     Detaches popup (dialog/notification/etc.) from the page
     @param {$} [$dialog] object representing popup
     */
    Odigeo.UIElements.hideDialog = function($dialog) {
        // Show logo
        $('#page .logo').removeClass('hidden');
        $dialog.detach();

        if (!$dialog.data('detached')) {
            Odigeo.trigger('dialogs:hidden', {dialogID: $dialog.data('dialog-id')});
            $dialog.data('detached', true);
        }
    };

    Odigeo.UIElements.hideAllDialogs = function() {
        _.each(this.dialogs, this.hideDialog);
    };

    Odigeo.UIElements.enhanceConfirmationDialog = function(popupDiv, okCallback, cancelCallback) {
        var $el;
        var showPopup;
        var hideDialog;
        var saveChanges;
        var discardChanges;

        $el = (popupDiv instanceof $) ? popupDiv : $(popupDiv);

        showPopup = function() {
            Odigeo.UIElements.showDialog($el);
            $el.find('.dialog_close_hint_icon').on(Odigeo.Events.tap, hideDialog);
            $el.find('.dialog_btn_save').on(Odigeo.Events.tap, saveChanges);
            $el.find('.dialog_btn_discard').on(Odigeo.Events.tap, discardChanges);
        };

        hideDialog = function() {
            $el.find('.dialog_close_hint_icon, .dialog_btn_save, .dialog_btn_discard').off(Odigeo.Events.tap);
            $el.detach();
        };

        saveChanges = function() {
            okCallback();
            hideDialog();
        };

        discardChanges = function() {
            cancelCallback();
            hideDialog();
        };

        return {
            show: showPopup,
            hide: hideDialog,
        };
    };

    // Ready-made dialogs
    Odigeo.UIElements.show0Error = function() {
        var translations = Odigeo.UIElements.translations.err0;
        var page = Odigeo.History.getPageNameFromFragment();
        var popup = this.createDialog({
            headerText: translations.header,
            content: '<div class="od-ui-dialog-filter">' + translations.content + '</div>',
            dialogClasses: 'no-background dialog_error',
            buttons: [{
                text: translations.button,
                style: 'od-ui-dialog-button-default',
                handler: function() {
                    Odigeo.UIElements.hideDialog(popup);
                    window.location.href = translations.link;
                    Odigeo.trigger('analytics:tracking', {
                        type: 'trackEvent',
                        data: {page: page, action: 'back_end_errors', label: '0_screen_button_error'},
                    });
                },
            }],
        });

        // Analytics: event tracking
        Odigeo.trigger('analytics:tracking', {
            type: 'trackEvent',
            data: {page: page, action: 'back_end_errors', label: '0_screen_error'},
        });

        this.hideAllDialogs();
        this.showDialog(popup);
    };

    Odigeo.UIElements.show404Error = function() {
        var translations = Odigeo.UIElements.translations.err404;
        var popup = Odigeo.UIElements.createDialog({
            headerText: translations.header,
            content: '<div class="od-ui-dialog-filter">' + translations.content + '</div>',
            dialogClasses: 'no-background dialog_error',
        });

        // Analytics: event tracking
        Odigeo.trigger('analytics:tracking', {
            type: 'trackEvent',
            data: {
                page: Odigeo.History.getPageNameFromFragment(),
                action: 'back_end_errors',
                label: '404_screen_error',
            },
        });

        this.hideAllDialogs();
        this.showDialog(popup);
    };

    Odigeo.UIElements.show500Error = function(image) {
        var translations = Odigeo.UIElements.translations.err500;
        var button;
        var popup;

        if (!_.isUndefined(image) && image) {
            popup = Odigeo.UIElements.createDialog({
                headerText: '',
                content: '<div class="od-ui-dialog-image-err500"></div>',
                dialogClasses: 'white-background aligned-top dialog_error',
                imageClass: 'image-padding',
            });
        } else {
            button = {
                text: translations.button,
                style: 'od-ui-dialog-button-default',
                handler: function() {
                    Odigeo.UIElements.hideDialog(popup);
                    window.location.href = translations.link;
                },
            };

            popup = Odigeo.UIElements.createDialog({
                headerText: translations.header,
                content: '<div class="od-ui-dialog-filter">' + translations.content + '</div>',
                buttons: [button],
                dialogClasses: 'no-background dialog_error',
            });
        }

        // Analytics: event tracking
        Odigeo.trigger('analytics:tracking', {
            type: 'trackEvent',
            data: {
                page: Odigeo.History.getPageNameFromFragment(),
                action: 'back_end_errors',
                label: 'server_down_screen_error',
            },
        });

        this.hideAllDialogs();
        this.showDialog(popup);
    };

    Odigeo.UIElements.showSessionLoginExpirationError = function() {
        var page = Odigeo.History.getPageNameFromFragment();
        var sessionLoginExpirePages = Odigeo.Settings.getProperty('sessionLoginExpirePages');

        if (_.indexOf(sessionLoginExpirePages, page) < 0 ||
                _.isNull(Odigeo.Utils.readCookie('sso_remember_me'))) {
            return;
        }

        Odigeo.Router.navigate('loginexpired');
    };



    Odigeo.UIElements._getCategoryAnalytics = function(page) {
        var category = 'home';
        switch (page) {
            case 'results':
                category = 'flights_results';
                break;
            case 'details':
                category = 'flights_pax_page';
                break;
            case 'payment':
                category = 'flights_pay_page';
                break;
            case 'confirmation':
                category = 'flights_confirmation_page';
                break;
        }
        return category;
    };

    Odigeo.UIElements.showLightboxWarning = function(imageClass, primaryAction, secondaryAction, translations) {
        var buttons = [];
        var $popup;
        var $header;
        var isModal = !_.isFunction(secondaryAction);
        var $image = $('<div>').addClass(imageClass);
        var $headerTitle = $('<p>', {
            'text': translations.headerTitle,
            'class': 'odf-h2 odf-text-neutral-700 odf-space-outer-bottom-m',
        });
        var $description = $('<p>', {
            'html': translations.description,
            'class': 'odf-text-lg odf-text-neutral-600 odf-space-outer-bottom-2xl',
        });

        $header = $('<div>').append($image).append($headerTitle).append($description);
        buttons.push({
            text: $('<p>', {'text': translations.primaryButton}),
            style: 'prisma-btn prisma-btn-highlight prisma-btn-round prisma-btn-block odf-space-outer-bottom-m',
            handler: function(evt) {
                evt.stopPropagation();
                evt.preventDefault();
                Odigeo.UIElements.hideDialog($popup);
                if (_.isFunction(primaryAction)) {
                    primaryAction();
                }
            },
        });
        if (!isModal) {
            buttons.push({
                text: $('<a>', {'text': translations.secondaryButton}),
                style: 'prisma-btn prisma-btn-default prisma-btn-round prisma-btn-block',
                handler: function(evt) {
                    evt.stopPropagation();
                    evt.preventDefault();
                    Odigeo.UIElements.hideDialog($popup);
                    if (_.isFunction(secondaryAction)) {
                        secondaryAction(true);
                    }
                },
            });
        }

        $popup = Odigeo.UIElements.createDialog({
            headerText: $header,
            buttons: buttons,
            dialogClasses: 'lightbox_warning od-ui-dialog-lightbox',
            hasCloseButton: false,
            closeOnTapOuterBox: false,
            closeOnNavigate: true,
        });
        if (!isModal) {
            $popup.find('.dialog_close_hint_icon').on(Odigeo.Events.tap, secondaryAction);
        }
        $popup.find('.od-ui-dialog-close-hint-icon').toggleClass('odf-hidden', isModal);
        Odigeo.UIElements.showDialog($popup);
    };
}());
